// extracted by mini-css-extract-plugin
module.exports = {"cookie-policy-wrapper":"cookie-policy_cookie-policy-wrapper__21P_v"};